import { useEffect, useState } from "react";
import { ProSidebarProvider, useProSidebar } from "react-pro-sidebar";
import { Outlet } from "react-router-dom";
import OrexSidebar from "../components/OrexSidebar";
import TopMenu from "../components/TopMenu";
import moment from "moment";
import ScreenLoader from "../components/common/ScreenLoader";
import { connect } from "react-redux";
import "rsuite/dist/rsuite.min.css";

import "../styles/admin/Orex.css";
import "@/styles/common/common.css";
import "@/styles/admin/developer.css";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import { ToastContainer } from "react-toastify";




const AdminLayout = (props) => {

    const { collapseSidebar, collapsed } =
        useProSidebar();

    const [screenLoading, setScreenLoading] = useState(false);

    useEffect(() => {
        // console.log("props in Admin Panel===", props.isLoading);
        setScreenLoading(props.isLoading);
    }, [props]);

    return (
        <div className="admin-pages">
            <SeoHelmet
                title={seoConfig.default.title}
                description={seoConfig.default.description}
                keywords={seoConfig.default.keywords}
                author={seoConfig.default.author}
            />
            <div style={{ display: "flex", height: "100vh", background: "#f5f5f9" }}>
                <div className={`sidebar-container ${collapsed ? 'collapsed' : ''}`}>

                    <OrexSidebar width={"300px"} collapsed={collapsed} collapseSidebar={collapseSidebar} />

                </div>
                {
                    screenLoading && <ScreenLoader />
                }
                <div className={`content main-web-content ${collapsed ? 'collapsed' : ''} `} >
                    <TopMenu collapseSidebar={collapseSidebar} />
                    <Outlet /> {/* 👈 dynamic admin pages */}
                    <p className='copyright-text'>© Copyright {moment().year()} All Rights Reserved.</p>
                </div>


            </div>
            <ToastContainer />
        </div >)
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.screenLoading.isLoading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(AdminLayout);